module.exports = __webpack_public_path__ + "static/img/bg-id.fd09d142.png";